import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, MenuItem, Select } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { SwichActiveIcon, SwichGreenActiveIcon, SwichIcon, UserDeleteIcon } from '../../components/icons'

const styles = theme => ({
    email: {
        // marginTop: theme.spacing(8),
        cursor: 'pointer'
    },
    sms: {
        marginTop: theme.spacing(4),
        cursor: 'pointer'
    },
    unregister: {
        marginTop: theme.spacing(5),
        cursor: 'pointer'
    },
    marketing: {
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.background.secondary,
        padding: theme.spacing(3, 4),
        borderRadius: theme.spacing(4)
    },
});

function SettingsView(props) {
    const { classes, t, showLoading, email_opt_out, app_name, onUpdateMarketingInformation, sms_opt_out, currentLanguge, onChangeLanguage } = props
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.onClose()}
                title={t('setting_title')}
                children={<DrawerItem classes={classes} t={t}
                    showLoading={showLoading}
                    email_opt_out={email_opt_out}
                    app_name={app_name}
                    onUpdateMarketingInformation={onUpdateMarketingInformation}
                    sms_opt_out={sms_opt_out}
                    currentLanguge={currentLanguge}
                    onChangeLanguage={onChangeLanguage}
                    languages={props.languages}
                    setShowConfirmDeleteUser={props.setShowConfirmDeleteUser}

                />} />

        </div>
    );
}
function DrawerItem(props) {
    const { t, classes, showLoading, email_opt_out, app_name, onUpdateMarketingInformation, sms_opt_out, onChangeLanguage, currentLanguge } = props;
    return (
        <Grid item>
            <Grid item xs={12}>
                <CustomTypo variant="subtitle2" light>{t('marketing_information')}</CustomTypo>
            </Grid>
            <Grid item xs={12}>
                <CustomTypo variant="body2" light>{t('marketing_information_desc')}{app_name}{" "}{t('marketing_information_desc_2')}</CustomTypo>
            </Grid>
            <Grid item xs={12} className={classes.marketing}>
                {<Grid item xs={12} container className={classes.email} onClick={() => onUpdateMarketingInformation('email_opt_out', !email_opt_out)}>
                    <Grid xs={10} item container justify='flex-start'>
                        <CustomTypo color='primary'>{t('setting_email')}</CustomTypo>
                    </Grid>
                    <Grid xs={2} item container justify='flex-end'>
                        {showLoading ? <CustomizedCircularProgress /> : (email_opt_out ? <SwichGreenActiveIcon /> : <SwichIcon />)}
                    </Grid>
                </Grid>}

                {<Grid item xs={12} container className={classes.sms} onClick={() => onUpdateMarketingInformation('sms_opt_out', !sms_opt_out)}>
                    <Grid xs={10} item container justify='flex-start'>
                        <CustomTypo color='primary'>{t('setting_sms')}</CustomTypo>
                    </Grid>
                    <Grid xs={2} item container justify='flex-end'>
                        {showLoading ? <CustomizedCircularProgress /> : (sms_opt_out ? <SwichGreenActiveIcon /> : <SwichIcon />)}
                    </Grid>
                </Grid>}
                <hr />
                {<Grid item xs={12} container className={classes.sms}>
                    <Grid xs={10} item container justify='flex-start'>
                        <CustomTypo color='primary'>{t('setting_language')}</CustomTypo>
                    </Grid>
                    <Grid xs={2} item container justify='flex-end'>
                        {/* <CustomTypo color='primary'>{currentLanguge === 'EN' ? t('english') : t('greek')}</CustomTypo> */}
                        {props.languages && props.languages.length > 0 && <Grid item className={classes.language} container alignItems='center' justify='center'>
                            <Select
                                disableUnderline
                                id="setting-select-languages"
                                value={currentLanguge}
                                onChange={(event) => props.onChangeLanguage(event.target.value)}
                            >
                                {props.languages.map((item, index) => {
                                    return <MenuItem key={index} value={item.value}>{t(`${item.tran_label}`)}</MenuItem>
                                })}
                            </Select>
                        </Grid>}
                    </Grid>
                </Grid>}
            </Grid>
            <Grid xs={12} container item className={classes.unregister} onClick={() => props.setShowConfirmDeleteUser(true)} id="setting_section_unregister">
                <Grid item xs={10}>
                    <CustomTypo variant="subtitle2" light>{t('unregister')}</CustomTypo>
                </Grid>
                <Grid item xs={2} container justify='flex-end'>
                    <UserDeleteIcon />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <CustomTypo light variant="body2">{t('unregister_desc')}</CustomTypo>
            </Grid>
            {/* {showLoading && <CustomizedCircularProgress />} */}
        </Grid>
    )
}

export default withStyles(styles)(withTranslation()(SettingsView));